// extracted by mini-css-extract-plugin
module.exports = {"GoogleAuthButton":"styles_GoogleAuthButton__25x_j","Icon":"styles_Icon__R4mgm"};